export default __webpack_public_path__ + "static/media/663.7f4ef97d.png";